import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import { capitalize } from "./capitalize";
//@ts-expect-error ToDo: fix this
export var capitalizeHyphenated = function capitalizeHyphenated(str) {
  return str && typeof str === 'string' ? str.split('-').map(capitalize).join('-') : str;
};